import _ from "lodash";

export const MakeGptInspectable = (a: any, ingoreList :string[] = []) => {
  const duplicate = _.clone(a);


  if (Array.isArray(a)) {
    return duplicate.map((item: any) => MakeGptInspectable(item));
  } else if (typeof a !== 'object' || a == null) {
    return;
  } else {
    // console.warn("Input is neither an object nor an array of objects.");
    // return a;
  }


  if(duplicate['availableDormerMaterials'] && ingoreList.indexOf('availableDormerMaterials') === -1) {
    duplicate['availableDormerMaterials'] = null;
  }

  const handleCase = (caseString: string) => {
    if(duplicate &&duplicate[caseString] && ingoreList.indexOf(caseString) === -1) {
      duplicate[caseString] = null;
    }
  }

  handleCase('availableDormerMaterials');
  handleCase('configuredDormerColor');
  handleCase('dormerColors');
  handleCase('copiedFrom');
  handleCase('childSectionFragments')

  return duplicate;
}
